<template>
  <button
    class="storefront-btn-blue lg:mr-0 mr-4"
    type="button"
    @click="onCall"
    aria-label="Call this pro"
  >
    <svg-vue icon="phone-solid" class="fill-white h-4 lg:h-5 inline-block mr-3" />
    <span class="inline-block">Call</span>

  </button>
</template>

<script>
export default {
    methods: {
        onCall() {
            this.$emit('call');
        },
    },
};
</script>